module.exports = __webpack_public_path__ + "static/media/parking-for-fleets.8a63cf65.webp";